import { transformHump } from '$common/utils/string'
import languageUtils from '$common/utils/language';
import globalEn from './en/index';
import globalKm from './km/index';
import globalZh from './zh/index';
import storage from '$common/utils/storage';
// 国际化语言配置
// 项目语言包
//  从 navigator 里先获取语言
let  isMerchantApp = navigator.userAgent.toLowerCase().indexOf("supermerchant") !== -1;
let  isWownowApp =  navigator.userAgent.toLowerCase().indexOf("wownow") !== -1;
let  isPC =  !/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent);
let  isWeb =  !isWownowApp && !isMerchantApp && !isPC;
let navigatorLanguage = languageUtils.getPageHeaderCurrentLanguage;

if(isWeb) {
  navigatorLanguage = languageUtils.justGetPageHeaderCurrentLanguage;
}
let locale = navigatorLanguage.indexOf('zh') !== -1 ? 'zh' : navigatorLanguage.indexOf('en') !== -1 ? 'en' : 'km';

export default {
  use: (Vue, VueI18n) => {
    Vue.use(VueI18n);
    //  初始化 i18n 对象
    const i18n = new VueI18n({
      locale, // 设置语言环境
      fallbackLocale: locale,
      messages: {
        en: {
          home: globalEn
        },
        km: {
          home: globalKm
        },
        zh: {
          home: globalZh
        }
      },
      silentTranslationWarn: true // 禁止没匹配警告
    });
    return { i18n };
  }
}
